import axios from "axios";
import api from "../../../api/api";
import Loader from "../../../components/loader";
import { useState } from "react";
import { toast } from 'react-toastify';


export const paypal_allowed_countries = [
    "AUD",
    "BRL",
    "CAD",
    "CNY",
    "CZK",
    "DKK",
    "EUR",
    "HKD",
    "HUF",
    "ILS",
    "JPY",
    "MYR",
    "MXN",
    "TWD",
    "NZD",
    "NOK",
    "PHP",
    "PLN",
    "GBP",
    "RUB",
    "SGD",
    "SEK",
    "CHF",
    "THB",
    "USD",
  ];

 

  // export const getPaymentGatewayFees = async props => {
  //   const { currency_code, useAtom, usePaypal, openPopup, gateWayData } = props
  
    
  
  //   let request = {
  //     url: `/api/v1/payment-gateway/${props.institute_id}?is_updated_payment_req=true`,
  //     token: props.student_auth

  //   }
  //   api
  //     .getAuth(request)
  //     .then(res => {
  //       if (res.status == 200 && res.data.statusCode == 200) {
  //         if (currency_code == 'INR' && props.student_country_details.currency_code == 'INR') {
  //           if (props.pr) {
  //             gateWayData(props.pr)
  //             setAtomData('Client', props.pr.Atom)
  //           } else {
  //             alert('fail')
  //           }
  //         } 
  //         // else if (paypal_allowed_countries.includes(currency_code) && res.data.result.PayPal) {
  //         //   // use paypal
  //         //   usePaypal(props.PayPal.is_proctur_payment_gateway == 'Y' ? 'Proctur' : 'Client')
  //         // } else {
  //         //   message(langdata.not_allowed_payment[dlang], 'fail')
  //         // }
  //       } else {
  //         alert(res.data.message, 'fail')
  //       }
  //     })
  //     .catch(err => {
  //       if (err && err.response && err.response.status == 403) {
  //         // dispatch({ type: 'LOGOUT', message: err.response })
  //         alert("403 error")
  //       } else {
  //         alert('fail')
  //       }
  //     })
  // }
  export const getPaymentGatewayChecking = async (
    props,
    updateData
  ) => {
    const { institute_id, student_auth } = props;
      let request={
        url:`/api/v1/payment-gateway/${institute_id}?is_updated_payment_req=true`,
      token: student_auth}
    
    api
      .getAuth(request)
    .then(async (res) => {
      if (res?.status == 200) {
        if (res?.data?.result?.inst_sett_det?.is_payment_enabled) {
          updateData(res?.data?.result);
        }
      }
    });
  };
  
  // export const getPaymentGateway = async (props) => {
  //   console.log(props, "checkprops");
  //   const {
  //     student_auth,
  //     setLoader,
  //     useAtom,
  //     useRazorpay,
  //     institute_id,
  //     country_id,
  //     currency_code,
  //     amount,
  //     usePaypal,
  //     message,
  //     dispatch,
  //     country_details,
  //     select_payment_gateway,
  //   } = props;
    
  //   let request = {
  //     url: `/api/v1/payment-gateway/${institute_id}?is_updated_payment_req=true`,
  //     token: student_auth

  //   }
  //   api
  //     .getAuth(request)
  //     .then(async (res) => {
  //       setLoader(false);
  //       if (res.status == 200 && res.data.statusCode == 200) {
         
  //         if (Object.keys(res?.data?.result).length == 0) {
  //           console.log(
  //             "We apologize, but our online payment processing is currently unavailable.For assistance, please contact your institute. Thank You!"
  //           );
  //         }
  //         if (currency_code == "INR") {
  //           if (
  //             res.data.result.Atom &&
  //             res.data.result.Atom.is_active == "Y" &&
  //             select_payment_gateway == "atom"
  //           ) {
  //             //use atome
  //             useAtom(
  //               res.data.result.Atom.is_proctur_payment_gateway == "Y"
  //                 ? "Proctur"
  //                 : "Client",
  //               res.data.result.Atom?.merchant_id,
  //               res.data.result.Atom?.email_id
  //             );
  //           } else {
  //             //use razorpay
  //             // useAtom(
  //             //   res.data.result.Atom.is_proctur_payment_gateway == "Y"
  //             //     ? "Proctur"
  //             //     : "Client"
  //             // );
  //             useRazorpay();
  //           }
  //         } else if (
  //           paypal_allowed_countries.includes(currency_code) &&
  //           res.data.result.PayPal
  //         ) {
  //           //use paypal
  //           usePaypal(
  //             res.data.result.PayPal.is_proctur_payment_gateway == "Y"
  //               ? "Proctur"
  //               : "Client"
  //           );
  //         } else {
  //           message("e", "You are not allowed to do payment.");
  //         }
  //       } else if (
  //         currency_code == "INR" &&
  //         country_details.currency_code == "INR"
  //       ) {
  //         //use razorpay
  //         useRazorpay();
  //       } else {
  //         message("e", res.data.message);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoader(false);
  //       if (country_details.currency_code == "INR" && currency_code == "INR") {
  //         //use razorpay
  //         useRazorpay();
  //       } else if (err && err.response && err.response.status == 403) {
  //         dispatch({
  //           type: "LOGOUT",
  //           message:
  //             err.response.data && err.response.data.message
  //               ? err.response.data.message
  //               : "",
  //         });
  //       } else {
  //         console.log("e", err);
  //       }
  //     });
  // };
  
  export const getAtomPaymentURL = async (payload, setLoader) => {
    setLoader(true);
    let token = ''
    let cid = 0
    let request = {
        url:`/api/v1/payment-gateway/payment/token`,
        
        data: payload}
    await api
      .post(request)
      .then(res => {
        if (res.data.statusCode == 200 && res.data.result.token_id !== '') {
          token = res.data.result.token_id
          cid = res.data.result.cid
        } else {
          alert(res.data.message)
        }
      })
      .catch(err => {
        if (err.response && err.response.message) {
          alert(err.response.message)
        } else {
          alert("unableToPay")
        }
      })
      .finally(() => setLoader(false))
    return { token, cid }}
  
  export const getPaypalPaymentURL = async (payload) => {
    let url = '';
    let flag = false;

    let request = {
      url: `/api/v1/payment-gateway/paypal/payment`,
      headers: {Authorization: "MTAwMzkwfDE6ZTYzNmFkOjEwMDU5M3wtMQ=="},
      data: payload
    };

    await api
      .post(request)
      .then((res) => {
        if (
          res.status == 200 &&
          res.data.statusCode == 200 &&
          res.data &&
          res.data !== "" &&
          res.data.result &&
          res.data.result !== ""
        ) {
          flag = true;
          url = res.data.result;
        } else if (
          res.status == 200 &&
          res.data.statusCode == 200 &&
          res.data &&
          res.data.result
        ) {
          flag = false;
          toast.error(res.data.message || "Payment processing failed");
        } else if (
          res.status == 200 &&
          res.data.statusCode == 200 &&
          res.data &&
          res.data == ""
        ) {
          flag = false;
          toast.error("Unable to process payment. Please try again later.");
        }
      })
      .catch((err) => {
        console.error("PayPal API Error:", err);
        flag = false;

        if (err.response && err.response.data && err.response.data.message) {
          toast.error(err.response.data.message);
        } else if (err.response && err.response.status === 400) {
          toast.error("Bad request. Please check your payment details.");
        } else if (err.response && err.response.status === 403) {
          toast.error("Payment not authorized. Please contact support.");
        } else if (err.response && err.response.status === 500) {
          toast.error("Server error. Please try again later.");
        } else {
          toast.error("Unable to process payment. Please try again.");
        }
      });

    if (flag) {
      return url;
    } else {
      return "";
    }
  };
  
  export const getPaymentType = async (
    props,
    opnAlrtPopForNotIntegratePayGat
  ) => {
    const {
      student_auth,
      setLoader,
      institute_id,
      currency_code,
      amount,
      message,
      dispatch,
      country_details,
      setType,
      updateData,
    } = props;
   
    let request = {
      url:`/api/v1/payment-gateway/${institute_id}?is_updated_payment_req=true`,
      headers:{ Authorization: student_auth}
    }
    api
      .get(request)
      .then(async (res) => {
        setLoader(false);
        if (res.status == 200 && res.data.statusCode == 200) {
          if (Object.keys(res?.data?.result).length == 0) {
            opnAlrtPopForNotIntegratePayGat();
          }
          if (currency_code == "INR") {
            if (res.data.result.Atom || res.data.result.Razorpay) {
              setType("both");
            } else if (
              res.data.result.Atom &&
              res.data.result.Atom.is_active == "Y"
            ) {
              //use atom
              setType("atom");
            } else if (
              res.data.result.Razorpay &&
              res.data.result.Razorpay.is_active == "Y"
            ) {
              //use razorpay
              updateData(res.data.result.Razorpay);
              setType("razorpay");
            }
          } else if (
            paypal_allowed_countries.includes(currency_code) &&
            res.data.result.PayPal
          ) {
            //use paypal
            setType("paypal");
          } else {
            message("e", "You are not allowed to do payment.");
          }
        } else if (
          currency_code == "INR" &&
          country_details.currency_code == "INR"
        ) {
          //use razorpay
          // setType("razorpay");
        } else {
          message("e", res.data.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        if (country_details.currency_code == "INR" && currency_code == "INR") {
          //use razorpay
          // setType("razorpay");
        } else if (err && err.response && err.response.status == 403) {
          dispatch({
            type: "LOGOUT",
            message:
              err.response.data && err.response.data.message
                ? err.response.data.message
                : "",
          });
        } else {
         console.log("e", err);
        }
      });
  };
  